import React, { useEffect, useState } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import './BusinessNotification.css';
import BusinessSidebar from "../../BusinessSidebar";
import Header from "../../BusinessHeaderAfterLogin";
import Footer from "../../BusinessFooterAfterLogin";
import Image from 'react-bootstrap/Image';
import API from '../../../Utils/Api';
import loader from '../../../assests/loader.gif';
import { Link } from 'react-router-dom';

const BusinessNotification = () => {

    const [loading, setLoading] = useState(true);
    const [last_page, setLastpage] = useState(1);
    const [current_page, setCurrentpage] = useState(1);
    const [notifications, setNotifications] = useState([]);

    useEffect(() => {
        document.title = `Business Notification | Local Bells`;
        document.getElementById('bodywrap').className = 'businoti';

        let formData = new FormData();
        if(localStorage.getItem("business_id")){
            formData.append('business_id', localStorage.getItem("business_id"));
        }
        formData.append(`per_page`, 10);
        formData.append('page', '');
        var url = 'get_notification_business';

        API.post(url, formData)
            .then(response => {
                setLoading(false);
                if (response.data.status === false) {

                } else {
                    setLastpage(response.data.data.pagination.last_page);
                    setNotifications(response.data.data.notification);
                }
            }).catch(error => {
                setLoading(false);
            });

    }, []);

    // State to toggle sidebar visibility
    const [isSidebarVisible, setIsSidebarVisible] = useState(false);

    // Function to toggle sidebar visibility
    const toggleSidebar = () => {
        setIsSidebarVisible((prev) => !prev);
    };

    const getNotification = () => {
        setLoading(true);
        var currentpage = current_page + 1;
        let formData = new FormData();
        if(localStorage.getItem("business_id")){
            formData.append('business_id', localStorage.getItem("business_id"));
        }
        formData.append('per_page', 10);
        formData.append(`page`, currentpage);
        var url = 'get_notification_business';

        API.post(url, formData)
            .then(response => {
                setLoading(false);
                if (response.data.status === false) {

                } else {
                    setCurrentpage(currentpage);
                    setLastpage(response.data.data.pagination.last_page);

                    setNotifications(prevNotification => [...prevNotification, ...response.data.data.notification]);
                }
            }).catch(error => {
                setLoading(false);
            });
    }

    return (
        <>
            <section className="main-cont-box">
                <Container>
                    <Row>
                        <BusinessSidebar isVisible={isSidebarVisible} setIsVisible={setIsSidebarVisible} />
                        <Col md={12} lg={9} xl={9} xxl={10} className='main-cont-box-right'>
                            <Header toggleSidebar={toggleSidebar} />
                            <div className='nei-cont'>
                                <div className='noti-box'>
                                    <h3>Notification</h3>
                                    {notifications.map((val, index) => {
                                        let url = "#";

                                          if (val.type === "deal_clipped" || val.type === "deal_redeemed") {
                                            url = `/business/my-deal`;
                                          }

                                          if (val.type === "deal_like" || val.type === "deal_disliked") {
                                            url = `/business/orders`;
                                          }

                                          
                                        return (
                                            <Link to={url} className="text-decoration-none">
                                            <Row className='mx-0'>
                                                <Col md={12} className={index % 2 === 0 ? 'dark-noti' : 'white-noti'}>
                                                    <Row>
                                                        <Col xs={12} sm="auto">

                                                            {['deal_redeemed', 'deal_clipped'].includes(val.type) && (<Image src={process.env.REACT_APP_BASE_URL + 'assets/images/noti1.webp'} className="img-fluid np-icn" alt="noti1" />)}

                                                            {['deal_like', 'deal_disliked'].includes(val.type) && (<Image src={process.env.REACT_APP_BASE_URL + 'assets/images/noti4.webp'} className="img-fluid np-icn" alt="noti4" />)}

                                                            {['new_business', 'new_deal'].includes(val.type) && (<Image src={process.env.REACT_APP_BASE_URL + 'assets/images/noti5.webp'} className="img-fluid np-icn" alt="noti5" />)}

                                                        </Col>
                                                        <Col xs={12} sm>
                                                            <h6>{val.title}</h6>
                                                            <h6>{val.body}</h6>
                                                        </Col>
                                                        <Col xs={12} sm="auto">
                                                            <p>{val.date}</p>
                                                        </Col>
                                                    </Row>
                                                </Col>
                                            </Row>
                                            </Link>
                                        );
                                    })}

                                    {current_page !== last_page && (
                                    <Row className='text-center load-more'>
                                        <Col md={12}>
                                            <Link onClick={getNotification} className='blue-link'>Load More</Link>
                                        </Col>
                                    </Row>
                                    )}

                                </div>
                                <div className='footer-org footer'>
                                    <Footer />
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
            {loading && (
                <div className="loadingClass">
                    <img src={loader} alt="loader" />
                </div>
            )}
        </>
    )
}

export default BusinessNotification;


